import type { ReactNode } from "react";

type EmptyStateProps = {
  icon?: string;
  title: string;
  description?: string;
  children?: ReactNode;
};

export default function EmptyState({
  icon = "ri-video-line",
  title,
  description,
  children,
}: EmptyStateProps) {
  return (
    <div className="surface-card flex flex-col items-center justify-center px-6 py-14 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={`${icon} text-2xl`} aria-hidden="true" />
      </div>
      <h3 className="text-base font-semibold text-foreground-900">{title}</h3>
      {description ? (
        <p className="mt-2 max-w-md text-xs leading-relaxed text-foreground-500 md:text-sm">
          {description}
        </p>
      ) : null}
      {children ? <div className="mt-5 flex flex-wrap items-center justify-center gap-2">{children}</div> : null}
    </div>
  );
}